import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import { ui } from 'theme/discover';

/**
 * Onde moram os EventCardV2 das seções da home. No celular é uma faixa
 * horizontal de cartões de largura fixa (a largura é o que mostra que há mais
 * para o lado), como no app; no desktop, uma grade de três.
 *
 * A faixa avança sobre o respiro lateral da página (16px) para a rolagem ir
 * até a borda da tela, e o respiro em volta dos cartões é o da sombra deles,
 * que a rolagem cortaria.
 */
export const EventCardsRail = styled.div`
    display: flex;
    gap: 12px;
    width: calc(100% + 32px);
    margin: -6px -16px 0;
    padding: 6px 16px 14px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x proximity;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    & > div {
        flex: 0 0 200px;
        scroll-snap-align: start;
        scroll-margin-left: 16px;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
        width: 100%;
        margin: 0;
        padding: 0;
        overflow: visible;

        & > div {
            min-width: 0;
        }
    }
`;

/** A linha de contagem entre o título da seção e os cartões ("8 eventos em Pelotas"). */
export const RailCaption = styled.p`
    margin: -4px 0 12px;
    padding: 0;
    font-size: 13px;
    color: ${ui.inkSoft};

    strong {
        font-weight: 700;
        color: ${ui.ink};
    }
`;
